import { useQuery } from '@tanstack/react-query';

import Axios from '@/lib/axios-instance';

type Props = {
  skip: number;
  limit: number;
  sourceType: string;
  status?: string;
};

export const getTrainingHistory = async (
  skip: number,
  limit: number,
  sourceType: string,
  status?: string,
) => {
  try {
    let url = `/crawl-url/list?source_type=${sourceType}&skip=${skip}&limit=${limit}`;
    if (status) {
      // Convert UI status values to API values
      const apiStatus = status === 'success' ? 'true' : status === 'failed' ? 'false' : status;
      url += `&status=${apiStatus}`;
    }
    const response = await Axios.get(url);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useGetTrainingHistory = ({ skip, limit, sourceType, status }: Props) => {
  const questions = useQuery({
    queryKey: ['get_training_history', skip, limit, sourceType, status],
    queryFn: () => getTrainingHistory(skip, limit, sourceType, status),
  });

  return questions;
};
